import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=2d6b72ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6b72ae"]])

export default __exports__